/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const selectAllCustomer = (state: { customer: any }) => state.customer.customers;
export const selectNoCustomer = (state: { customer: any }) => state.customer.noCustomer;
export const selectSelectedCustomer = (state: { customer: any }) => state.customer.selectedCustomer;
export const selectCustomerPagination = (state: { customer: any }) => state.customer.pagination;